import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button} from 'antd'
import {withTranslation} from 'react-i18next'
@inject('intelligentQueryStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()

  componentDidMount() {
    const {intelligentQueryStore, title, record} = this.props
    intelligentQueryStore.onGetAdvancedApplicationList()
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'question': record?.question,
        'description': record?.description,
        'advanced_application': record?.advanced_application,
      })
    }
  }

  handleOk = () => {
    const {intelligentQueryStore, handleCancel, title, record} = this.props
    const {advancedApplicationList} = intelligentQueryStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? record?.id : null,
        "question": fieldsValue?.question,
        "description": fieldsValue?.description,
        "advanced_application": advancedApplicationList?.[0].id || '',
      }
      intelligentQueryStore.onSqlExampleAddAction(params, title).then(res=> {
        if (res?.data?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }

  render() {
    const { intelligentQueryStore, addModalVisible, handleCancel, title, t } = this.props
    const {advancedApplicationList} = intelligentQueryStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`intelligentQuery.editSqlExample`) : t(`intelligentQuery.createSqlExample`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addSqlExample" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item name="question" label={t(`intelligentQuery.questionDesc`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`intelligentQuery.questionDesc`)}`,
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="description" label={t(`intelligentQuery.sqlContent`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`intelligentQuery.sqlContent`)}`,
                }]}>
                  <Input.TextArea placeholder={t(`general.pleaseEnter`)} rows={4} />
                </Form.Item>
              </Col>
              {/* <Col span={24}>
                <Form.Item name="advanced_application" label={t(`intelligentQuery.advancedApplication`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseSelect`)} ${t(`intelligentQuery.advancedApplication`)}`,
                }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {advancedApplicationList?.map(item => (
                      <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)